import React, { Component } from 'react'
import {
    Alert,
    Stack,
    Menu,
    MenuItem,
    Checkbox,
    Paper,
    TableBody,
    TableContainer,
    TableCell,
    Box,
    Tooltip,
} from '@mui/material'
import LoadingData from '@/Components/Elements/Loading/LoadingData'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faBell } from '@fortawesome/pro-duotone-svg-icons/faBell'
import { faEdit } from '@fortawesome/pro-duotone-svg-icons/faEdit'
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDown'
import { faEye } from '@fortawesome/pro-duotone-svg-icons/faEye'

import DisplayItem from '@/Components/DisplayItems/DisplayItem'
import ExpiredModal from '@/Components/Pages/Upgrade/ExpiredModal'
import SearchDefDossier from '../../Utils/SearchDefDossier'
import LoadingDefault from '@/Components/Elements/Loading/LoadingDefault'
import DossierModalEditButton from '@/Components/Elements/DossierModalEditButton'
import ContentDossierSend from '@/feature/ContentDossier/Toolbar'
import DefDossierListTableHead from './DefDossierListTableHead'
import DefDossierListTableFooter from './DefDossierListTableFooter'
import DisplayItemHelper from '@/util/DisplayItemHelper'
import {
    StyledButton,
    CompactButton,
} from '@/Components/Elements/StyledComponents/Buttons'
import {
    StyledTable,
    StyledTableRow,
} from '@/Components/Elements/StyledComponents/Tables'
import { isInteractiveClick } from '@/util/clickGuards'

const contentClickSelector =
    '.contentData, .displayItem, .list-group-item, .badge'

const isContentClick = (event) => {
    const target = event.target
    const currentTarget = event.currentTarget

    return (
        target instanceof Element &&
        currentTarget instanceof Element &&
        Boolean(
            target.closest(contentClickSelector) ||
                currentTarget.closest(contentClickSelector)
        )
    )
}

class DefDossierList extends Component {
    constructor(props) {
        super(props)
        this.ddListRef = React.createRef()

        const rawSort =
            this.props.ddiSort ??
            this.props.defDossier?.sort ??
            this.props.defDossier?.settings?.sort ??
            []
        const sortOptions = DisplayItemHelper.mapSortSettings(rawSort)

        this.state = {
            embedded: false,
            error: false,
            archived: null,
            items: [],
            actionBtns: [],
            dossierQuery: this.props.dossierQuery
                ? this.props.dossierQuery
                : null,
            inlineEdit: false,
            quickShow: true,
            quickEdit: false,
            limit: 50,
            loading: false,
            page: 0,
            sort: sortOptions,
            selected: [],
            results: [],
            subscriptions: [],
            aggregations: [],
            aggregationResults: [],
            pager: {},
            search: null,
            socketDossierIds: [],
            showActionModal: '',
            anchorEl: null,
            activeField: null,
        }

        this.checkAll = this.checkAll.bind(this)
        this.handleContent = this.handleContent.bind(this)
        this.isSelected = this.isSelected.bind(this)
        this.onChangePage = this.onChangePage.bind(this)
        this.getSearchFilter = this.getSearchFilter.bind(this)
        this.doSearch = this.doSearch.bind(this)
        this.fetchItems = this.fetchItems.bind(this)
        this.applySort = this.applySort.bind(this)
        this.handleEntriesChange = this.handleEntriesChange.bind(this)
        this.updateCheckedStatus = this.updateCheckedStatus.bind(this)
        this.fetchDisplayItems = this.fetchDisplayItems.bind(this)
        this.search = this.search.bind(this)
        this.onDeleteSuccess = this.onDeleteSuccess.bind(this)
        this.renderAggregateField = this.renderAggregateField.bind(this)
        this.loadSocketCallbacks = this.loadSocketCallbacks.bind(this)
        this.handleDossierModal = this.handleDossierModal.bind(this)
        this.isAllowedDd = this.isAllowedDd.bind(this)
        this.canBeArchived = this.canBeArchived.bind(this)
        this.isSortable = this.isSortable.bind(this)
        this.isCustomActionButton = this.isCustomActionButton.bind(this)
    }

    fetchNewDossier(dossierId, isNew = true) {
        if (isNew) {
            let socketDossiers = this.state.socketDossierIds
            socketDossiers.push(dossierId)
            this.setState({ socketDossierIds: socketDossiers })
        }

        let filter = this.getSearchFilter()

        if (this.state.aggregations && this.state.aggregations.length > 0) {
            for (let i = 0; i < this.state.aggregations.length; i++) {
                filter[this.state.aggregations[i].id + '_aggregate'] =
                    this.state.aggregations[i].aggregate
            }
        }

        filter.archived = this.state.archived

        filter.dossierId = dossierId

        let originalResults = this.state.results
        this.props.kedo
            .api()
            .get(this.props.kedo.api().getContentDossierEndpoint(), {
                params: filter,
            })
            .then((response) => {
                let newContents = [
                    ...originalResults.contents,
                    ...response.data.results.contents,
                ]
                originalResults.contents = newContents

                let newDossiers = [
                    ...response.data.results.dossiers,
                    ...originalResults.dossiers,
                ]
                originalResults.dossiers = newDossiers

                this.setState({
                    error: false,
                    results: originalResults,
                })
            })
    }

    handleDossierModal(remove, close) {
        if (remove) {
            this.fetchItems()
        }

        if (close) {
            this.setState({
                inlineEdit: false,
                quickEdit: false,
                quickShow: true,
            })
        }
    }

    fetchItems() {
        let filter = this.getSearchFilter()
        this.setState({ loadingContent: true })

        if (this.state.aggregations && this.state.aggregations.length > 0) {
            for (let i = 0; i < this.state.aggregations.length; i++) {
                filter[this.state.aggregations[i].id + '_aggregate'] =
                    this.state.aggregations[i].aggregate
            }
        }

        filter.archived = this.state.archived

        this.props.kedo
            .api()
            .get(this.props.kedo.api().getContentDossierEndpoint(), {
                params: filter,
            })
            .then((response) => {
                this.setState({
                    error: false,
                    loadingContent: false,
                    results: response.data.results,
                    actionBtns: response.data.results.items.filter(
                        (item) => this.isCustomActionButton(item) === true
                    ),
                    pager: response.data.pager,
                    selected: [],
                })
            })
            .catch((error) =>
                this.setState({
                    loadingContent: false,
                    error: true,
                    expired:
                        error.response && error.response.status === 402
                            ? true
                            : false,
                })
            )
    }

    onDeleteSuccess() {
        if (this.props.kedo.socket().getSocket()) {
            this.props.kedo
                .socket()
                .getSocket()
                .emit('displayItem:delete', {
                    defDossierId: this.props.defDossierId,
                    sender: this.props.kedo.socket().getSocket().id,
                    room:
                        window.location.pathname.split('/')[1] !==
                        'contentdossier'
                            ? 'environment:' +
                              this.props.kedo.env().getEnvironmentId()
                            : null,
                })
        }

        this.fetchItems()
    }

    loadSocketCallbacks() {
        this.props.kedo
            .socket()
            .getSocket()
            .on('displayItem:fetch', (data) => {
                if (
                    this.props.kedo.socket().getSocket().id !==
                        data.sender.id &&
                    data.defDossierId === this.props.defDossierId
                ) {
                    this.fetchItems()
                }
            })
    }
    doSearch(searchParams, dossierQuery, archived) {
        this.setState(
            {
                archived: archived,
                search: searchParams,
                dossierQuery: dossierQuery,
            },
            this.fetchItems
        )
    }

    checkAll(event) {
        if (!this.state.results || !this.state.results.dossiers) {
            return
        }

        if (true === event.target.checked) {
            this.setState({
                selected: this.state.results.dossiers.map((item) => item.id),
            })
        } else {
            this.setState({ selected: [] })
        }
    }

    handleEntriesChange(event) {
        this.setState({ limit: event.target.value })
        setTimeout(() => this.fetchItems(), 200)
    }

    isCustomActionButton(listItem) {
        if (
            listItem?.def_dossier_def_field?.def_field?.type ===
            'customActionButton'
        ) {
            return true
        }

        return false
    }

    isListField(listItem) {
        if (listItem?.def_dossier_def_field?.def_field?.type === 'list') {
            return true
        }

        return false
    }

    /**
     * Check if the listItem as a specific custom field
     * @param listItem
     * @returns {boolean}
     */
    isOtherDisplayItemField(listItem) {
        if (
            !listItem.def_dossier_link &&
            !listItem.def_dossier_def_field &&
            listItem.settings &&
            listItem.settings.dossier_data
        ) {
            return true
        } else if (
            !listItem.def_dossier_link &&
            !listItem.def_dossier_def_field &&
            listItem.settings &&
            listItem.settings.block
        ) {
            return true
        } else if (this.isCustomActionButton(listItem)) {
            return true
        }

        return false
    }

    getValue(listItem, dossierData, dossier) {
        let isOtherDisplayItemField = this.isOtherDisplayItemField(listItem)
        if (!dossierData && true !== isOtherDisplayItemField) {
            return ''
        }

        let isListItem = this.isListField(listItem)
        let singleDossierData = false

        singleDossierData = dossierData.find(
            (data) => data.content.id === listItem.id
        )

        if (
            singleDossierData &&
            singleDossierData.content &&
            singleDossierData.content.skip === true
        ) {
            return ''
        }

        if (singleDossierData && singleDossierData.content) {
            singleDossierData = singleDossierData.content.content
        }

        if (
            isListItem === true &&
            listItem.settings &&
            listItem.settings.fast_switch === true
        ) {
            return (
                <DisplayItem
                    kedo={this.props.kedo}
                    changeValue={() => {
                        //TODO
                    }}
                    content={singleDossierData}
                    dossier={dossier}
                    errors={null}
                    item={listItem}
                    key={listItem.id}
                    mode={'list'}
                />
            )
        }

        if (true === isOtherDisplayItemField) {
            //Dossier data list field
        } else if (!singleDossierData || singleDossierData.length <= 0) {
            return ''
        }
        return (
            <DisplayItem
                kedo={this.props.kedo}
                changeValue={() => {
                    //TODO
                }}
                fetchItems={this.fetchItems}
                content={singleDossierData}
                dossier={dossier}
                errors={null}
                item={listItem}
                key={listItem.id}
                mode={'list'}
            />
        )
    }

    canBeArchived() {
        let dds = this.props.kedo.env().getCurrentEnvironmentDefDossiers()
        if (dds.length <= 0) {
            return false
        }

        return (
            dds.filter(
                (item) =>
                    item.id === this.props.defDossierId &&
                    item.archiveable === true
            ).length > 0
        )
    }

    updateCheckedStatus(event, dossier) {
        let selected = this.state.selected
        selected = selected.filter((checked) => checked !== dossier.id)

        if (event.target.checked === true) {
            selected.push(dossier.id)
        }

        this.setState({ selected: selected })
    }

    clearSort(e, listItem) {
        e.preventDefault()

        //Clear dossier column sorts.
        if (listItem.settings && listItem.settings.dossier_data) {
            let sortFields = this.state.sort.filter(
                (liItem) =>
                    liItem.item.setttings &&
                    liItem.item.settings.dossier_data !==
                        listItem.settings.dossier_data
            )
            this.setState({ sort: sortFields }, this.fetchItems)
            return
        }

        //Clear normal data fields.
        if (!listItem && !listItem.def_dossier_def_field) {
            return
        }

        let sortFields = this.state.sort.filter(
            (liItem) =>
                liItem.item.def_dossier_def_field.id !=
                listItem.def_dossier_def_field.id
        )
        this.setState({ sort: sortFields }, this.fetchItems)
    }

    applySort(e, listItem, listOrder) {
        e.preventDefault()

        if (
            listItem &&
            listItem.settings &&
            listItem.settings.dossier_data &&
            (listItem.settings.dossier_data === 'created_at' ||
                listItem.settings.dossier_data === 'modified_at')
        ) {
            let sortFields = this.state.sort.filter(
                (liItem) =>
                    !liItem.item ||
                    !liItem.item.settings ||
                    !liItem.item.settings.dossier_data ||
                    liItem.item.settings.dossier_data !==
                        listItem.settings.dossier_data
            )
            sortFields.push({ item: listItem, order: listOrder })
            this.setState({ sort: sortFields }, this.fetchItems)

            return
        }

        if (!listItem && !listItem.def_dossier_def_field) {
            return
        }

        let sortFields = this.state.sort.filter(
            (liItem) =>
                liItem.item.def_dossier_def_field.id !=
                listItem.def_dossier_def_field.id
        )
        sortFields.push({ item: listItem, order: listOrder })
        this.setState({ sort: sortFields }, this.fetchItems)
    }

    isSortable(listField) {
        if (
            listField &&
            listField.settings &&
            listField.settings.dossier_data &&
            (listField.settings.dossier_data === 'created_at' ||
                listField.settings.dossier_data === 'modified_at')
        ) {
            return true
        }

        if (!listField || !listField.def_dossier_def_field) {
            return false
        }

        if (
            listField.def_dossier_def_field &&
            listField.def_dossier_def_field.def_field.type === 'textarea'
        ) {
            return false
        }

        return true
    }

    isAllowedDd(credential) {
        const kedo = this.props.kedo

        return kedo
            .env()
            .isAllowedDefDossier(
                credential,
                this.props.defDossierId,
                kedo.user()
            )
    }

    renderTableHead(results, actionBtns) {
        if (!results || !results.items) {
            return
        }

        let ddArchiveable = this.canBeArchived()
        let listItems = results.items.filter(
            (item) => item.view === 'list' && !this.isCustomActionButton(item)
        )
        let allDossiers = results.dossiers
        let selectedItems = this.state.selected
        let selectedDossiers = allDossiers.filter((item) =>
            selectedItems.find((selectedId) => selectedId === item.id)
        )
        let archivedDossiers =
            ddArchiveable &&
            selectedDossiers.find((item) => item.archived === true)
        let dearchivedDossiers =
            ddArchiveable &&
            selectedDossiers.find((item) => item.archived === false)
        const kedo = this.props.kedo

        let extraColumns = 3
        if (actionBtns.length > 0) {
            extraColumns = 4
        }

        return (
            <DefDossierListTableHead
                results={this.state.results}
                actionBtns={actionBtns}
                selected={this.state.selected}
                dossiers={this.state.results?.dossiers || []}
                sort={this.state.sort}
                showActionModal={this.state.showActionModal}
                limit={this.state.limit}
                pager={this.state.pager}
                subscriptions={this.state.subscriptions}
                mode={this.props.mode}
                defDossierId={this.props.defDossierId}
                showEmail={this.props.showEmail}
                multiAdd={this.props.multiAdd}
                addDossier={this.props.addDossier}
                filterDossier={this.props.filterDossier}
                kedo={this.props.kedo}
                checkAll={this.checkAll}
                applySort={this.applySort}
                clearSort={this.clearSort}
                handleEntriesChange={this.handleEntriesChange}
                fetchItems={this.fetchItems}
                onDeleteSuccess={this.onDeleteSuccess}
                getSearchFilter={this.getSearchFilter}
                setShowActionModal={(modal) =>
                    this.setState({ showActionModal: modal })
                }
                setShowAllExportModal={(modal) =>
                    this.setState({ showAllExportModal: modal })
                }
                isAllowedDd={this.isAllowedDd}
                isSortable={this.isSortable}
                isCustomActionButton={this.isCustomActionButton}
                canBeArchived={this.canBeArchived}
            />
        )
    }

    onChangePage(number) {
        this.setState({ page: number })
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.page = number
        this.fetchItems()
    }

    fetchDisplayItems() {
        if (this.state.loading) {
            return
        }
        const api = this.props.kedo.api()

        let params = {
            params: {
                view: ['search', 'advanced-search'],
                defDossier: this.props.defDossierId,
                limit: 200,
            },
        }

        api.getCached(api.getDisplayItemEndpoint(), params).then((response) => {
            this.setState({
                loading: false,
                items: response.data.results,
            })
            this.fetchItems()
        })
    }

    renderTableContent(results) {
        if (
            !this.state.results ||
            !this.state.results.dossiers ||
            this.state.results.dossiers.length <= 0
        ) {
            return
        }

        let listItems = results.items.filter(
            (item) => item.view === 'list' && !this.isCustomActionButton(item)
        )

        return (
            <TableBody sx={{}}>
                {results.dossiers.map((dossier) =>
                    this.renderContentRow(
                        results.contents.filter(
                            (dataItem) => dataItem.id === dossier.id
                        ),
                        dossier,
                        listItems,
                        this.state.actionBtns
                    )
                )}
            </TableBody>
        )
    }

    isSelected(dossier) {
        return this.state.selected.find(
            (selectedId) => selectedId === dossier.id
        )
    }

    renderContentRow(dossierData, dossier, listItems, actionBtns) {
        const doTransition =
            this.props.mode === 'embeddedList' &&
            this.state.socketDossierIds.find((item) => item === dossier.id)
                ? true
                : false

        return (
            <StyledTableRow
                key={dossier.id}
                hover
                hoverActions
                variant="compact"
                verticalAlign="top"
                className={`contentRow ${
                    dossier.archived ? 'archivedDossier' : ''
                }`}
                sx={{
                    borderLeft: doTransition ? '8px solid #bddbf0' : undefined,
                    fontWeight: doTransition ? 'bold' : undefined,
                    ...(dossier.archived && { opacity: 0.6 }),
                }}
            >
                <TableCell className={'contentData'} style={{ width: '3%' }}>
                    <Checkbox
                        checked={this.state.selected.includes(dossier.id)}
                        onChange={(event) =>
                            this.updateCheckedStatus(event, dossier)
                        }
                        value={dossier.id}
                        size="small"
                        sx={{ p: 0 }}
                    />
                </TableCell>
                {this.props.showEmail === true ? (
                    <TableCell>
                        <ContentDossierSend
                            kedo={this.props.kedo}
                            dossier={dossier}
                        />
                    </TableCell>
                ) : null}
                <TableCell
                    className={'contentData'}
                    style={{ textAlign: 'center', width: '3%' }}
                >
                    {this.state.subscriptions.find(
                        (item) => item.content_dossier_id === dossier.id
                    ) ? (
                        <FontAwesomeIcon icon={faBell} />
                    ) : null}
                </TableCell>
                {listItems.map((listItem) => (
                    <TableCell
                        key={listItem.id}
                        className={'contentData'}
                        sx={{ cursor: 'pointer' }}
                        onClick={(event) => {
                            if (this.isCustomActionButton(listItem) === false) {
                                this.handleContent(event, dossier)
                            }
                        }}
                    >
                        {this.getValue(listItem, dossierData, dossier)}
                    </TableCell>
                ))}
                {actionBtns.length > 0 ? (
                    <TableCell className={'contentData'}>
                        <Stack
                            direction="column"
                            spacing={0.5}
                            sx={{
                                alignItems: 'flex-start',
                                minWidth: 'max-content',
                            }}
                        >
                            {actionBtns.map((actionBtn) =>
                                this.getValue(actionBtn, dossierData, dossier)
                            )}
                        </Stack>
                    </TableCell>
                ) : null}
                <TableCell
                    data-cell-inline-edit
                    sx={{
                        verticalAlign: 'top',
                        whiteSpace: 'nowrap',
                        textAlign: 'center',
                        width: '80px',
                        minWidth: '80px',
                    }}
                >
                    <Box
                        sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 0.5,
                            lineHeight: 0,
                        }}
                    >
                        <Tooltip
                            title={this.props.kedo.t('open_view_mode')}
                            arrow
                        >
                            <CompactButton
                                data-cell-inline-action
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flex: '0 0 28px',
                                    width: '28px',
                                    height: '28px',
                                    minWidth: '28px',
                                    p: 0,
                                    m: 0,
                                    verticalAlign: 'middle',
                                }}
                                dense
                                onClick={() => {
                                    let socketDossiers =
                                        this.state.socketDossierIds.filter(
                                            (item) => item !== dossier.id
                                        )
                                    this.setState({
                                        inlineEdit: dossier.id,
                                        socketDossierIds: socketDossiers,
                                        quickEdit: false,
                                        quickShow: true,
                                    })
                                }}
                            >
                                <FontAwesomeIcon icon={faEye} />
                            </CompactButton>
                        </Tooltip>
                        <Tooltip
                            title={this.props.kedo.t('open_edit_mode')}
                            arrow
                        >
                            <CompactButton
                                data-cell-inline-action
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flex: '0 0 28px',
                                    width: '28px',
                                    height: '28px',
                                    minWidth: '28px',
                                    p: 0,
                                    m: 0,
                                    verticalAlign: 'middle',
                                }}
                                dense
                                onClick={() => {
                                    let socketDossiers =
                                        this.state.socketDossierIds.filter(
                                            (item) => item !== dossier.id
                                        )
                                    this.setState({
                                        inlineEdit: dossier.id,
                                        socketDossierIds: socketDossiers,
                                        quickEdit: true,
                                        quickShow: false,
                                    })
                                }}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </CompactButton>
                        </Tooltip>
                    </Box>
                </TableCell>
            </StyledTableRow>
        )
    }

    handleContent(event, dossier) {
        event.stopPropagation()

        if (isInteractiveClick(event) || !isContentClick(event)) {
            return
        }

        if (this.props.embedded) {
            this.setState({
                inlineEdit: dossier.id,
                quickEdit: false,
                quickShow: true,
            })
        } else {
            if (
                event.ctrlKey ||
                (navigator.platform == 'MacIntel' && event.metaKey)
            ) {
                window.open(`/contentdossier/${dossier.id}`, '_blank')
                return
            }
            if (this.props.onClick) {
                this.props.onClick(dossier)
            }
            this.toTop()
        }
    }

    handleSelect = (field, aggregate) => {
        let aggrs = this.state.aggregations.filter(
            (aggrItem) => aggrItem.id !== field.id
        )

        if (aggregate) {
            aggrs.push({ id: field.id, aggregate: aggregate })
        }

        this.setState(
            { anchorEl: null, activeField: null, aggregations: aggrs },
            this.fetchItems
        )
    }

    getAggregateOptions = (field) => {
        if (field.def_dossier_link) return ['unique']

        if (!field.def_dossier_def_field) return []

        const type = field.def_dossier_def_field.def_field.type
        switch (type) {
            case 'amount':
            case 'time':
                return ['avg', 'sum', 'min', 'max']
            case 'date':
                return ['min', 'max']
            case 'list':
                return ['unique']
            default:
                return []
        }
    }

    renderAggregateField(field) {
        let aggrOptions = this.getAggregateOptions(field)

        if (!aggrOptions.length) return null

        const curVal = this.state.aggregations.find(
            (item) => item.id === field.id
        )

        return (
            <>
                <StyledButton
                    className={'aggregate'}
                    dense
                    sx={{
                        border: 'none',
                        width: '28px',
                        height: '28px',
                    }}
                    onClick={(e) => {
                        this.setState({
                            anchorEl: e.currentTarget,
                            activeField: field,
                        })
                    }}
                >
                    <FontAwesomeIcon icon={faChevronDown} />
                </StyledButton>
                <Menu
                    anchorEl={this.state.anchorEl}
                    open={this.state.activeField?.id === field.id}
                    onClose={() => {
                        this.setState({
                            anchorEl: null,
                            activeField: null,
                        })
                    }}
                >
                    <MenuItem onClick={() => this.handleSelect(field)}>
                        —
                    </MenuItem>

                    {aggrOptions.map((aggrOption, aggrIndex) => (
                        <MenuItem
                            key={aggrIndex}
                            selected={curVal?.aggregate === aggrOption}
                            onClick={() => this.handleSelect(field, aggrOption)}
                        >
                            {this.props.kedo.t(aggrOption.toUpperCase())}
                        </MenuItem>
                    ))}
                </Menu>
            </>
        )
    }

    toTop() {
        window.scrollTo(0, 0)
    }

    fetchSubscriptions() {
        if (
            !this.state.results ||
            !this.state.results.dossiers ||
            this.state.results.dossiers.length <= 0
        ) {
            return
        }
        let ids = this.state.results.dossiers.map((item) => item.id)
        this.props.kedo
            .api()
            .post(
                this.props.kedo.api().getContentDossierEndpoint() +
                    '/subscriptions',
                { ids: ids }
            )
            .then((response) => this.setState({ subscriptions: response.data }))
    }

    getSearchFilter() {
        let filter = {
            defDossier: this.props.defDossierId,
            limit: this.state.limit,
            page: this.state.page,
        }

        if (this.state.dossierQuery && this.state.dossierQuery.length > 0) {
            filter.dossierQuery = this.state.dossierQuery
        }

        if (this.state.sort && this.state.sort.length > 0) {
            filter.sort = []
            filter.sortOrder = []
            this.state.sort.forEach((filterItem) => {
                const dossierData = filterItem.item?.settings?.dossier_data
                const fieldId = filterItem.item?.def_dossier_def_field?.id
                const sortField = dossierData
                    ? dossierData
                    : DisplayItemHelper.isValidSortFieldId(fieldId)
                    ? fieldId
                    : null

                if (sortField === null) return

                filter.sort.push(sortField)
                filter.sortOrder.push(filterItem.order)
            })
        }

        if (this.props.embedded) {
            filter.embedded = this.props.embedded
            filter.linkId = this.props.linkId
        }

        if (this.state.search && this.state.search.length > 0) {
            this.state.search.map((searchItem) => {
                if (
                    searchItem &&
                    searchItem.value &&
                    searchItem.value.custom === 'date'
                ) {
                    filter[searchItem.id + '_type'] = searchItem.value.type
                    if (searchItem.value.type === 'between') {
                        filter[searchItem.id + '_end'] = searchItem.value.date2
                    }
                    filter[searchItem.id] = searchItem.value.date1
                } else if (typeof searchItem.value === 'string') {
                    filter[searchItem.id] = searchItem.value
                } else if (
                    searchItem &&
                    searchItem.value &&
                    searchItem.value.custom === 'slider'
                ) {
                    filter[searchItem.id + '_min'] = searchItem.value.min
                    filter[searchItem.id + '_max'] = searchItem.value.max
                    filter[searchItem.id] = '1'
                } else if (searchItem.value instanceof Array) {
                    let values = []
                    searchItem.value.map((valItem) => values.push(valItem.id))
                    filter[searchItem.id] = values
                }
            })
        }

        return filter
    }

    search(values, dossierQuery) {
        this.setState(
            {
                search: values,
                dossierQuery: dossierQuery,
            },
            this.fetchItems
        )
    }

    renderSearchFilter() {
        let searchItems = this.state.items.filter(
            (searchItem) =>
                searchItem.view === 'search' ||
                searchItem.view === 'advanced-search'
        )

        if (
            searchItems.length <= 0 ||
            this.props.embedded ||
            this.props.initSearch === false
        ) {
            return null
        }
        let defDossier = this.props.kedo
            .env()
            .getCurrentEnvironmentDefDossiers()
            .find((item) => item.id === parseInt(this.props.defDossierId))

        return (
            <SearchDefDossier
                doSearch={this.doSearch}
                kedo={this.props.kedo}
                defDossierId={this.props.defDossierId}
                dossierQuery={this.state.dossierQuery}
                defDossier={defDossier}
                items={searchItems}
                showArchive={this.canBeArchived()}
                resetSearch={() => this.setState({ search: null })}
                search={this.state.search}
                location={'DefDossierIndex'}
            />
        )
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.dossierQuery !== prevProps.dossierQuery) {
            this.fetchDisplayItems()
        }
    }

    componentDidMount() {
        if (this.props.kedo.socket().getSocket()) {
            this.loadSocketCallbacks()
        }

        this.fetchDisplayItems()
    }

    componentWillUnmount() {
        if (this.socket) {
            this.socket.removeListener('displayItem:fetch')
        }
    }

    render() {
        if (this.state.loading) {
            return (
                <Box sx={{ width: '100%', px: 2 }}>
                    <LoadingData />
                </Box>
            )
        }
        if (this.state.error) {
            return (
                <Box sx={{ width: '100%' }}>
                    {this.state.expired ? (
                        <ExpiredModal kedo={this.props.kedo} />
                    ) : null}
                    <Alert severity={'warning'}>
                        {this.props.kedo.t('Something went wrong')}.
                    </Alert>
                </Box>
            )
        }

        let listItems =
            this.state.results.items && this.state.results.items.filter
                ? this.state.results.items.filter(
                      (item) => item.view === 'list'
                  )
                : []

        let extraColumns = this.state.actionBtns.length > 0 ? 4 : 3

        return (
            <div>
                {this.renderSearchFilter()}
                <TableContainer
                    component={Paper}
                    elevation={0}
                    sx={{ overflowX: 'auto' }}
                >
                    <StyledTable
                        size="small"
                        sx={{
                            '& .MuiTableCell-root': {
                                py: 0.5,
                                px: 1,
                            },
                        }}
                        striped
                    >
                        {this.renderTableHead(
                            this.state.results,
                            this.state.actionBtns
                        )}
                        {this.state.loadingContent ? (
                            <TableBody sx={{}}>
                                <StyledTableRow variant="compact">
                                    <TableCell
                                        sx={{
                                            textAlign: 'center',
                                        }}
                                        colSpan={
                                            listItems.length + extraColumns
                                        }
                                    >
                                        <LoadingDefault />
                                    </TableCell>
                                </StyledTableRow>
                            </TableBody>
                        ) : (
                            this.renderTableContent(this.state.results)
                        )}
                        <DefDossierListTableFooter
                            loadingContent={this.state.loadingContent}
                            results={this.state.results}
                            pager={this.state.pager}
                            actionBtns={this.state.actionBtns}
                            kedo={this.props.kedo}
                            isCustomActionButton={this.isCustomActionButton}
                            renderAggregateField={this.renderAggregateField}
                            onChangePage={this.onChangePage}
                        />
                    </StyledTable>
                </TableContainer>
                {this.state.inlineEdit ? (
                    <DossierModalEditButton
                        onDeleteSuccess={() => this.handleDossierModal(true)}
                        showSaveClose={true}
                        onSuccess={(close) => {
                            this.handleDossierModal(true, close)
                        }}
                        onClose={() => this.handleDossierModal(false, true)}
                        embedded={this.props.embedded}
                        edit={true}
                        dossierId={this.state.inlineEdit}
                        kedo={this.props.kedo}
                        quickEdit={this.state.quickEdit}
                        quickShow={this.state.quickShow}
                    />
                ) : null}
            </div>
        )
    }
}

export default DefDossierList
